import * as React from 'react';

import CheckDidMount from 'ha/components/CheckDidMount';

const NoSSR: React.SFC = ({ children }) => (
  <CheckDidMount>{didMount => didMount && children}</CheckDidMount>
);

export default NoSSR;
